import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useEffect } from "react";

export const Route = createFileRoute("/_app/dashboard/metrics/growth")({
  component: RouteComponent,
});

function RouteComponent() {
  const navigate = useNavigate();

  // biome-ignore lint/correctness/useExhaustiveDependencies: navigate is stable from useNavigate
  useEffect(() => {
    navigate({ to: "/dashboard/metrics/highlights", replace: true });
  }, []);

  return null;
}
